import { CommonModule } from '@angular/common';
import {
    Component,
    ElementRef,
    EventEmitter,
    HostListener,
    Input,
    OnChanges,
    Output,
    SimpleChanges,
    SkipSelf,
} from '@angular/core';
import {
    ControlContainer,
    FormsModule,
    ReactiveFormsModule,
} from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { Router } from '@angular/router';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { TooltipComponent } from 'app/components/tooltip/tooltip.component';
import { MatTooltipModule } from '@angular/material/tooltip';

@Component({
    selector: 'input-general',
    templateUrl: './input-general-application.component.html',
    styleUrls: ['./input-general-application.component.scss'],
    standalone: true,
    imports: [
        FormsModule,
        CommonModule,
        MatIconModule,
        TranslateModule,
        ReactiveFormsModule,
        MatProgressSpinnerModule,
        TooltipComponent,
        MatTooltipModule,
    ],
    viewProviders: [
        {
            provide: ControlContainer,
            useFactory: (container: ControlContainer) => container,
            deps: [[new SkipSelf(), ControlContainer]],
        },
    ],
})
export class InputGeneralApplicationComponent implements OnChanges {
    @Input() label: string | null = null;
    @Input() currentValue: string = '';
    @Input() placeHolder: string = '';
    @Output() selectionChange: EventEmitter<any> = new EventEmitter<any>();
    @Input() mandatoryField: boolean = false;
    @Input() inputType: string = 'text';
    @Input() hideInput: boolean = false;
    @Input() resetPasswordButton: boolean = false;
    @Input() resetMobileButton: boolean = false;
    @Input() class: string = '';
    @Input() removeValue: boolean = false;
    @Input() backgroundOverride: string | undefined;

    @Input() errors: string[] = [];
    @Input() strength: null | number = null;
    @Input() strengthLabel: null | string = null;
    @Input() strengthColor: string = '#4b6eec';
    @Input() classOverrides: string | null = null;
    @Input() controlName?: string;
    @Input() maxlength: any;
    @Input() phoneNoCodeLabel?: string = undefined;
    @Output() phoneNoFieldChange: EventEmitter<any> = new EventEmitter<any>();
    @Output() resetMobile: EventEmitter<any> = new EventEmitter<any>();
    @Output() resetPassword: EventEmitter<any> = new EventEmitter<any>();
    @Input() verifyButton?: boolean = false;
    @Input() verifyCompanyRegNoLoading?: boolean = false;
    @Input() verifyIdentificationNoLoading?: boolean = false;
    @Input() verifyIdentificationNoBtn?: boolean = false;
    @Input() VerifiedIdentificationNo;
    @Input() disableCompanyRegVerifyBtn: boolean = false;
    @Input() disableIdentificationVerifyBtn: boolean = false;
    @Output() isCompanyRegNoVerified: EventEmitter<any> =
        new EventEmitter<any>();
    @Output() isIdentificationNoVerified: EventEmitter<any> =
        new EventEmitter<any>();
    @Input() buttonVerified?: boolean = false;
    @Input() identificationNoButtonVerified?: boolean = false;
    @Input() radioSelect?: boolean = false;
    @Input() radioSelectDesignation?: string = '';
    @Input() radioSelectName?: string = '';
    @Input() headerUnderline: boolean = false;
    @Input() tooltipDataHeading: any;
    @Input() TooltipData = {
        header: '',
        content: '',
        content2: '',
    };
    isTooltipOpenHeader: boolean = false;
    strengthArray = [0, 1, 2, 3];

    hide: boolean;
    hideResetPasswordButton: boolean;
    hideResetMobileButton: boolean;

    constructor(
        public router: Router,
        public translate: TranslateService,
        private el: ElementRef
    ) {
        this.hide = this.hideInput; // Set the initial value of hide based on hideInput
        this.hideResetPasswordButton = this.resetPasswordButton;
        this.hideResetMobileButton = this.resetMobileButton;
    }

    toggleHideInput() {
        this.hide = !this.hide;
    }
    toggleTooltipHeader() {
        this.isTooltipOpenHeader = !this.isTooltipOpenHeader;
    }

    toggleVerifyButton() {
        this.isCompanyRegNoVerified.emit(true);
    }

    toggleIdentificationVerifyButton() {
        this.isIdentificationNoVerified.emit(true);
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes?.hideInput?.currentValue === true) {
            this.hide = true;
        }
    }
    hideTooltip() {
        this.isTooltipOpenHeader = false;
    }
    resetPass() {
        this.resetPassword.emit(true);
    }

    resetMobilePhone() {
        this.resetMobile.emit(true);
    }
    @HostListener('document:click', ['$event'])
    handleClickOutside(event: Event) {
        if (!this.el.nativeElement.contains(event.target)) {
            this.isTooltipOpenHeader = false;
        }
    }
}
